import React from 'react';
import { Outlet } from 'react-router-dom';
import Pills from '@/components/Pills';
import Tabs from '@/components/Tabs';
import NavLink from '@/components/NavLink';
import ExternalLink from '@/components/ExternalLink';
import Icon from '@/components/Icon';
import {
  settingsCurrentPlanPath,
  settingsCurrentPlanForbiddenPath,
  legacyUsersUrl,
  legacyTeamsUrl,
  legacyGroupsUrl,
  legacySettingsUrl,
  legacyUserUrl,
  legacyAccountUrl
} from '@/routes';
import { useAuth } from '@/lib/auth';

function AccountBase() {
  const { user } = useAuth();
  const subMenuClassName = 'height-2 fw-normal';

  const accountActivePaths = settingsCurrentPlanPath || settingsCurrentPlanForbiddenPath;

  return (
    <>
      <Pills
        className='nav-settings-pills width-5'
      >
        <Tabs
          className='d-flex flex-column w-100 gap-5 p-4'
        >
          <Pills.Item>
            <NavLink
              className={subMenuClassName}
              href={accountActivePaths}
              end
            >
              <Icon name='agendor-logo-small' size='sm' className='me-2' />
              Plano
            </NavLink>
          </Pills.Item>

          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacyUsersUrl()}
              className={subMenuClassName}
              end
            >
              <Icon name='team' size='sm' className='me-2' />
              Usuários
            </NavLink>
          </Pills.Item>

          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacyTeamsUrl()}
              className={subMenuClassName}
              end
            >
              <Icon name='team' size='sm' className='me-2' />
              Equipes
            </NavLink>
          </Pills.Item>

          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacyGroupsUrl()}
              className={subMenuClassName}
              end
            >
              <Icon name='team' size='sm' className='me-2' />
              Grupos
            </NavLink>
          </Pills.Item>

          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacySettingsUrl('Privacidade')}
              className={subMenuClassName}
              end
            >
              <Icon name='lock' size='sm' className='me-2' />
              Privacidade da conta
            </NavLink>
          </Pills.Item>


          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacyUserUrl(user.id)}
              className={subMenuClassName}
              end
            >
              <Icon name='person' size='sm' className='me-2' />
              Meus dados
            </NavLink>
          </Pills.Item>

          <Pills.Item>
            <NavLink
              as={ExternalLink}
              href={legacyAccountUrl()}
              className={subMenuClassName}
              end
            >
              <Icon name='organization' size='sm' className='me-2' />
              Dados da conta
            </NavLink>
          </Pills.Item>
        </Tabs>
      </Pills>

      <Outlet />
    </>
  );
}

export default AccountBase;
